const Info = {
	rentayventa: {
		name: 'Renta y Venta',
		path: '/rentayventa',
		exact: true,
		icon: 'RENTA-Y-VENTA-ICONO.png',
		triangles : {
			"1": "Modelos nuevos, variados y en óptimas condiciones",
			"2": "Transporte de equipo. Las máquinas en donde se necesitan.",
			"3": "Venta de maquinaria. Adquiere tus propias maquinas a los mejores precios.",
			"4": "Soluciones inmediatas. Sin tiempos de espera excesivos.",
			"6": "Experiencia. No te arriesgues, con nosotros vas a la segura.",
		},
		bubbles: {
			"1": "Contamos con los modelos de maquinaria más recientes y de mejor rendimiento para tu servicio.",
			"2": "Nosotros llevamos las máquinas y equipos hasta el lugar de trabajo. ",
			"3": "Contamos con los más amplios catálogos de maquinaria de las mejores marcas y a los mejores precios.",
			"4": "Nuestra prioridad son nuestros clientes. Atendemos personalmente y de inmediato a nuestros clientes.",
			"6": "Más de 20 de años de experiencia ofreciendo soluciones con la más alta calidad.",
		},
	},
	demolicion: {
		name: 'Demolición',
		path: '/demolicion',
		icon: 'DEMOLICION-ICONO.png',
		backgroundImg: "../../img/test/IMP16.jpg",
		triangles: {
			"1": "Equipo apropiado y especializado para cada tipo de servicio.",
			"2": "Responsabilidad. Tomamos todas las consideraciones necesarias.",
			"3": "Presición. Ni mas, ni menos. Ejecutamos como lo necesitas.",
			"4": "Experiencia. Sabemos lo que hacemos, y lo hacemos bien.",
			"6": "Personal especializado, capacitado y responsable. Las mejores manos.",
		},
		bubbles: {
			"1": "Contamos con máquinas adecuadas para hacer frente a los retos de una demolición segura y limpia.",
			"2": "Somos una empresa confiable, seria y experimentada.",
			"3": "Planeamos todos los detalles con cálculos minuciosos para reducir riesgos al máximo.",
			"4": "Más de 1000 demoliciones exitosas.",
			"6": "Contamos con operadores de confianza capacitados, especializados y con experiencia. ",
		},
	},
	excavacion: {
		name: 'Excavación',
		path: '/excavacion',
		icon: 'EXCAVACION-ICONO.png',
		backgroundImg: "../../img/test/IMP18.jpg",
		triangles : {
			"1": "Equipo apropiado y especializado para cada tipo de servicio.",
			"2": "Personal especializado, capacitado y responsable. Las mejores manos.",
			"3": "Experiencia. Sabemos lo que hacemos, y lo hacemos bien.",
			"4": "¿Tienes dudas? Nosotros te asesoramos para que tomes la mejor decisión.",
			"6": "Zonificación: Sabemos de lo que está hecho todo México.",
		},
		bubbles: {
			"1": "Nuestras máquinas siempre en condiciones para excavaciones en terrenos de materiales tipo A, B y C.",
			"2": "Contamos con operadores de confianza capacitados, especializados y con experiencia.",
			"3": "Más de 1000 excavaciones exitosas.",
			"4": "Contamos con estudios como mecánica de suelos, composición geológica y más.",
			"6": "Conocemos las composiciones y necesidades de cualquier zona dentro de la república méxicana.",
		},
	},
	nivelacion: {
		name: 'Nivelación',
		path: '/nivelacion',
		icon: 'NIVELACION-ICONO.png',
		backgroundImg: "../../img/test/IMP42.jpg",
		triangles: {
			"1": "Equipo apropiado y especializado para cada tipo de servicio.",
			"2": "Personal especializado, capacitado y responsable. Las mejores manos.",
			"3": "Compactación y nivelación con la mejor tecnología.",
			"4": "Topografías precisas con aparatos de última generación",
			"6": "Precisión y exactitud de niveles de terrenos.",
		},
		bubbles: {
			"1": "Nuestras máquinas siempre están en óptimas condiciones mecánicas y calibradas para nivelación precisas y de calidad.",
			"2": "Contamos con operadores de confianza capacitados, especializados y con experiencia.",
			"3": "Evita fisuras y hundimientos en tu construcción. Máxima compresión de suelos y subsuelos.",
			"4": "Nuestros estudios te darán la mejor representación gráfica y características de tu terreno.",
			"6": "Facilita la construcción de tu proyecto con un terreno nivelado con la más alta precisión.",
		},
	},
	limpieza: {
		name: 'Limpieza',
		path: '/limpieza',
		icon: 'LIMPIEZA-ICONO.png',
		backgroundImg: "../../img/test/IMP27.jpg",
		triangles: {
			"1": "Equipo apropiado y especializado para cada tipo de servicio.",
			"2": "Eficiencia, equilibrio entre calidad y precio.",
			"3": "Retiro transporte y desecho de material a lugares autorizados.",
			"4": "Remoción de materiales químicos y peligrosos ",
			"6": "Siempre listos. Llamanos a la hora que desees.",
		},
		bubbles: {
			"1": "Máquinas adecuadas y en óptimas condiciones.",
			"2": "Rápido y bien hecho. Tu terreno estará limpio en el menor tiempo posible.",
			"3": "No te preocupes, !nosotros nos encargamos de la basura!",
			"4": "Contamos con la experiencia y conocimientos necesarios para el retiro de materiales de manejo delicado.",
			"6": "Estamos a tu servicio las 24 horas.",
		},
	},
	contacto: {
		name: 'contacto',
		path: '/contacto',
		icon: 'CONTACTO-ICONO.png',
		triangles : {
			"1": "contacto",
			"2": "contacto",
			"3": "contacto",
			"4": "contacto",
			"6": "contacto",
		},
	},
}

export default Info


// WEBPACK FOOTER //
// ./src/components/info.js